import React, { useEffect, useState } from "react";
import cx from "classnames";
import Space from "@Components/kindsum/New/Report/space";
import Soft from "@Components/kindsum/New/Report/soft";
import Performance from "@Components/kindsum/New/Report/performance";
import Secure from "@Components/kindsum/New/Report/secure";
import NavList from "./navList";
import styles from "./index.module.less";
interface IProps {
  data: {
    comfortModelYearId: number;
    comfortModelYearName: string;
    performanceModelYearId: number;
    performanceModelYearName: string;
    spaceModelYearId: number;
    spaceModelYearName: string;
    safeEquipModelYearId: number;
    safeEquipModelYearName: string;
  };
}

const ReportIndex: React.FC<IProps> = ({ data }) => {
  const [active, setActive] = useState("");
  // const [shockData, setShockData] = useState<ShockType[]>([]);
  const [navList, setNavList] = useState<{ title: string; value: number }[]>([]);

  useEffect(() => {
    const newList: any = [];
    !!data?.safeEquipModelYearId && newList.push({ title: "安全", value: data.safeEquipModelYearId });
    !!data?.spaceModelYearId && newList.push({ title: "空間", value: data.spaceModelYearId });
    !!data?.comfortModelYearId && newList.push({ title: "舒適", value: data.comfortModelYearId });
    !!data?.performanceModelYearId && newList.push({ title: "性能", value: data.performanceModelYearId });
    setNavList(newList);
    !!newList.length && setActive(newList[0].title);
  }, [data]);

  return (
    <div className={cx(styles["ReportIndex"], "w-282 h-410 pt-16 rounded-4")}>
      <div className='flex items-center justify-start px-12' id='ReportTab'>
        <NavList data={data} active={active} setActive={setActive} />
      </div>
      <div className='w-282'>
        {active === "安全" && (
          <Secure id={data.safeEquipModelYearId} safeEquipModelYearId={data.safeEquipModelYearId} />
        )}
        {active === "空間" && (
          <Space
            id={data.spaceModelYearId}
            spaceKindTitle={data.spaceModelYearName}
            spaceModelYearId={data.spaceModelYearId}
          />
        )}
        {active === "舒適" && <Soft id={data.comfortModelYearId} comfortModelYearId={data.comfortModelYearId} />}
        {active === "性能" && (
          <Performance performanceModelYearId={data.performanceModelYearId} spaceModelYearId={data.spaceModelYearId} />
        )}
      </div>
    </div>
  );
};

export default ReportIndex;
